<div *ngIf="
    !this.switchPostService?.useGeoLocBasedPostSelection;
    then postSelection;
    else geoLocSelection
  "></div>
<ng-template #postSelection>
  <div class="content">
    <h2 mat-dialog-title *ngIf="data == 'login'">Select Post</h2>
    <h2 mat-dialog-title *ngIf="data == 'button'">Switch Post</h2>
    <div mat-dialog-content>
      <div class="top-content">
        Select the post that you would like to
        <span *ngIf="data == 'login'"> continue with:</span>
        <span *ngIf="data == 'button'"> switch to:</span>
      </div>

      <mat-card class="example-card">
        <mat-card-content>
          <div class="row">
            <div class="col-md-8">
              <h3>Posts</h3>
            </div>
            <div class="col-md-4 text-center">
              <h3>Mark as Default</h3>
            </div>
          </div>
          <mat-radio-group aria-labelledby="Posts List" class="radio-group" [(ngModel)]="selectedPosts"
            (change)="selPostChange($event)">
            <div class="row switch-post-row" *ngFor="let post of posts; let i = index">
              <div class="col-md-10 vertical-center">
                <mat-radio-button class="radio-button" [value]="post">
                  <div [class.selected-post]="post == selectedPosts">
                    {{ post.postName }}
                    <span *ngIf="post.orgName">
                      {{ " , " + post.orgName }}</span>
                    <span *ngIf="i == selectedDefault"> (Default)</span>
                  </div>
                </mat-radio-button>
              </div>
              <div class="col-md-2 text-center">
                <button mat-icon-button [class.rotate-pin]="i == selectedDefault" (click)="onDefaultClick(i)">
                  <mat-icon [class.material-icons-outlined]="i != selectedDefault">
                    push_pin
                  </mat-icon>
                </button>
              </div>
            </div>
          </mat-radio-group>
        </mat-card-content>
      </mat-card>
      <!-- <p>
        <mat-checkbox class="checkbox" [(ngModel)]="checkValue" (change)="checkChange($event)">
          Don't show this dialog at the time of login.
        </mat-checkbox>
      </p> -->

      <!-- <div class="bottom-content">
        The Default Post will be used at the time of login.<br />
        For any issues related to post please raise Support Request.
      </div> -->
    </div>
    <div mat-dialog-actions [align]="'end'">
      <button mat-raised-button mat-dialog-close>Cancel</button>
      <button *ngIf="data?.origin == 'login'" mat-raised-button color="primary" (click)="onSwitch()" mat-dialog-close>
        <mat-icon>arrow_right_alt</mat-icon>
        Proceed
      </button>
      <button *ngIf="data?.origin == 'button'" mat-raised-button color="primary" (click)="onSwitch()" mat-dialog-close>
        <mat-icon>account_box</mat-icon>
        Switch Post
      </button>
    </div>
  </div>
</ng-template>
<!-- changes for geoLocBasedPostSelection by Arth --start -->
<ng-template #geoLocSelection>
  <div class="geoLocSelection">
    <h2 mat-dialog-title *ngIf="data?.origin == 'login'">
      {{ "switchPost.Select_Location" | translate }}
    </h2>
    <h2 mat-dialog-title *ngIf="data?.origin == 'button'">
      {{ "switchPost.Switch_Location" | translate }}
    </h2>
    <div mat-dialog-content class="my-4 paddingLeft14">
      <div class="container-fluid p-0">
        <form [formGroup]="switchPostForm" #formDirective="ngForm" class="form-group h-400">
          <div class="row m-0">
            <div class="col-md-4">
              <mat-label class="ng-select-label required-field">{{
                "Select " + this.countryLabel
              }}</mat-label>
              <ng-select id="country" formControlName="selectedCountry" appendTo="body" [clearable]="true"
                (change)="onCountryChange($event)">
                <ng-option *ngFor="let country of countries" [value]="country">{{ country }}</ng-option>
              </ng-select>
              <mat-error class="ng-select-error" *ngIf="
                  switchPostForm.controls['selectedCountry']?.touched &&
                  switchPostForm.controls['selectedCountry'].errors &&
                  switchPostForm.controls['selectedCountry'].errors.required
                ">
                {{ this.countryLabel + " is required" }}
              </mat-error>
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-4">
              <mat-label class="ng-select-label required-field">{{
                "Select " + this.stateLabel
              }}</mat-label>
              <ng-select id="state" formControlName="selectedState" appendTo="body" [clearable]="true"
                (change)="onStateChange($event)">
                <ng-option *ngFor="let state of selectedCountryState" [value]="state">{{
                  state?.stateName
                }}</ng-option>
              </ng-select>
              <mat-error class="ng-select-error" *ngIf="
                  switchPostForm.controls['selectedState']?.touched &&
                  switchPostForm.controls['selectedState'].errors &&
                  switchPostForm.controls['selectedState'].errors.required
                ">
                {{ this.stateLabel + " is required" }}
              </mat-error>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div mat-dialog-actions [align]="'end'">
      <button *ngIf="data?.origin == 'login'" mat-raised-button color="primary" [disabled]="!this.switchPostForm?.valid"
        (click)="onSwitch(true)" mat-dialog-close>
        <mat-icon>arrow_right_alt</mat-icon>
        Proceed
      </button>
      <button *ngIf="data?.origin == 'button'" mat-raised-button color="primary"
        [disabled]="!this.switchPostForm?.valid" (click)="onSwitch(true)" mat-dialog-close>
        <mat-icon>account_box</mat-icon>
        {{ "switchPost.Switch_Location" | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- changes for geoLocBasedPostSelection by Arth --end -->
